import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../typography/Typography';
import { CustomLink } from './styles';
const Link = ({ to, testId, textTestId, textType, children, className, ...rest }) => {
    return (_jsx(CustomLink, { className: className, "data-cy": testId, to: to, ...rest, children: _jsx(Typography, { testId: textTestId, fontFamily: "primary", type: textType || 'bodyButton', children: children }) }));
};
export default Link;
//# sourceMappingURL=Link.js.map